import type { Uploads } from '@/libs/interfaces'

export const mockUploads: Uploads[] = [
  {
    uploadID: 'upload-1',
    fileName: 'profile-anna-karlsson.jpg',
    profilePic: true,
    s3Key: 'mock/uploads/profile-anna-karlsson.jpg',
  },
  {
    uploadID: 'upload-2',
    fileName: 'vehicle-abc100-front.jpg',
    profilePic: false,
    s3Key: 'mock/uploads/vehicle-abc100-front.jpg',
  },
]

export const MOCK_PLACEHOLDER_IMAGE_URL = 'https://placehold.co/600x400?text=Care+of+Cars'
